import styled from "styled-components";
import "reactjs-popup/dist/index.css";
export const Container = styled.div`
  height: 100vh;
  overflow: hidden;
  padding: 30px;
`;

export const ModalContent = styled.div`
  font-size: 1.4rem;

  @media (max-height: 800px) {
    max-height: 600px;
    overflow-y: auto;
  }

  .content {
    padding: 20px 20px 20px;

    .top-content {
      background-color: rgba(249, 250, 253, 1);
      display: flex;
      justify-content: center;
      padding: 1.5rem 1rem;
      font-weight: 600;
      box-shadow: 1px 1px 7px 0px rgba(201, 201, 201, 0.5);
    }

    .checklist {
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      margin-top: 1rem;

      .list-item {
        min-height: 60px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 1px 1px 7px 0px rgba(201, 201, 201, 0.5);
        display: flex;
        padding-inline: 1rem;
        align-items: center;
        justify-content: space-between;
        margin: 0.6rem 0;

        .radio-container {
          display: flex;
          align-items: center;
          gap: 1rem;
          .radio {
            display: flex;
            align-items: center;
            gap: 4px;
          }
        }
      }
    }
  }
  .content > .confirmation-popup {
    width: 90% !important;
  }

  hr {
    opacity: 0.5;
    margin-top: 15px;
  }

  .button-container {
    display: flex;
    justify-content: space-between;

    padding: 10px 25px;

    button {
      width: 100%;
      font-size: 1.2em;
      background: #e71037;
      border: 2px solid #e71037;
      border-radius: 5px;
      color: #fff;

      padding: 7px 0px;
    }
  }
`;

export const Content = styled.div`
  margin: auto;
  height: calc(100vh - 180px);
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const Logo = styled.img`
  height: 89px;
  width: 315px;
`;

export const Title = styled.p`
  color: #4a4b4a;
  font-size: 1.6em;
  letter-spacing: 0;
  line-height: 27px;
  text-align: center;
  padding: 10% 0 5%;
`;

export const Subtitle = styled.p`
  color: #4a4b4a;
  font-size: 1.6em;
  letter-spacing: 0;
  line-height: 27px;
  text-align: center;
  padding: 0 0 10%;
`;

export const Header = styled.header`
  width: 100%;
  height: 35px;
`;
